import styled from "styled-components/macro";
import { Text, Button } from "@gcs/design-system/react";
import InputText from "./FormInputs/InputText";

export const StyledButton = styled(Button)(({ theme }) => ({
  background: theme.color.brandSecondary.light,
  color: theme.color.neutral["08"],
  borderRadius: "4px",
  marginBottom: "40px",
  marginTop: "30px",

  ":disabled": {
    opacity: "0.4",
  },
}));

export const FormContainer = styled.section(({ theme }) => ({
  gap: "40px",
}));

export const SubTitle = styled(Text)(({ theme }) => ({
  margin: "6px 0 40px",
}));

export const TwoInputContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoint.xl()]: {
    flexDirection: "row",
    gap: "150px",
  },
}));

export const InputName = styled(InputText)(({ theme }) => ({
  [theme.breakpoint.xl()]: {
    width: "600px",
    maxWidth: "600px",
  },
}));

export const InputCpfCnpj = styled(InputText)(({ theme }) => ({
  [theme.breakpoint.xl()]: {
    width: "480px",
  },
}));

export const InputPhone = styled(InputText)(({ theme }) => ({
  [theme.breakpoint.xl()]: {
    width: "400px",
    maxWidth: "400px",
  },
}));

export const InputEmail = styled(InputText)(({ theme }) => ({
  [theme.breakpoint.xl()]: {
    width: "700px",
    maxWidth: "700px",
  },
}));

export const ErrorLabel = styled(Text)(({ theme, error }) => ({
  display: error ? "block" : "none",
  color: theme.color.feedback.error,
  marginBottom: "30px",
  fontSize: "14px",
}));

export const FileContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoint.xl()]: {
    flexDirection: "row",
    gap: "40px",
  },
}));

export const InfoTitle = styled.p(({ theme }) => ({
  color: theme.color.neutral["02"],
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "160%",
}));

export const InfoText = styled.div(({ theme }) => ({
  p: {
    margin: 0,
    color: theme.color.neutral["02"],
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "160%",
    [theme.breakpoint.md()]: {
      fontSize: "20px",
    },
  },

  a: {
    color: theme.color.brandPrimary.light,
    fontSize: "18px",
    fontWeight: "500",
    lineHeight: "160%",
    textDecoration: "underline",
    [theme.breakpoint.md()]: {
      fontSize: "20px",
    },
  },
}));
